module.exports = __webpack_public_path__ + "img/evo_w.f207f0ce.svg";